import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import { DEFAULT_VIEW_MODE } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { portRecord } from 'services/ports';
import {
    setErrorHandlerAction,
    SetErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { ActionsType, SystemType } from 'types/system';
import { checkDifferent, getId } from 'utils/formHandlers';
import { PortManager } from 'utils/IndexedDB';
import { translate } from 'utils/translate';

interface SystemUpdatedModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    system: SystemType;
    id?: string;
    setSystemLoadingAction: SetSystemLoadingAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    //unused props but used in state and getDerivedStateFromProps
    data: any;
    actions: ActionsType | undefined;
}

interface SystemUpdatedModelState {
    //unused state
    errors: object;

    system: SystemType;

    //unused state
    data: any | null;
}

class SystemUpdatedModel extends Component<SystemUpdatedModelProps, SystemUpdatedModelState> {
    constructor(props: SystemUpdatedModelProps) {
        super(props);
        this.state = {
            system: props.system,
            data: props.data,
            errors: {},
        };
    }

    static getDerivedStateFromProps(props: SystemUpdatedModelProps, state: SystemUpdatedModelState) {
        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }
        return null;
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();

        this.props.setSystemLoadingAction(true);
        portRecord(localStorage.getItem('port_id'))
            .then(async (res) => {
                const originalPort: PortType = res.items;

                localStorage.removeItem('switchs');
                localStorage.removeItem('backgrounds');
                localStorage.removeItem('gridSettings');
                // Save **everything in IndexedDB** using PortManager
                const portManager = new PortManager();
                await portManager.savePort(originalPort);

                localStorage.setItem('port_id', originalPort.id.toString());
                localStorage.setItem('system', JSON.stringify(this.props.data));
                localStorage.setItem('viewMode', DEFAULT_VIEW_MODE);
                setTimeout(() => {
                    //@ts-ignore
                    window.location.reload();
                }, 200);
                this.props.actions?.onCancel();
            })
            .catch((error) => {
                this.props.setSystemLoadingAction(false);
                this.props.setErrorHandlerAction(error);
            });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('System update')} </div>
                    </div>

                    <div className="flex items-center gap-3 mb-3 text-gray-800">
                        {translate('The system has been updated , please click update to reload the system')}
                    </div>

                    <div className="flex justify-end items-center">
                        <div className="mt-5 flex gap-3">
                            <Button
                                onClick={this.handleFormCancel}
                                className="px-4 py-2 font-bold border border-gray-400"
                            >
                                {translate('Ignore')}
                            </Button>

                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Update')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    system: state.port.system,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SystemUpdatedModel);
